import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import {
  SystemPlaceOfPersonTypes,
  SYSTEM_PLACE_OF_PERSON_TYPE_LABELS,
  PlaceOfPerson,
} from "../../types/placeOfPerson";
import {
  EntityWithMetadataTableSuffixColumns,
  createConnectionFilterSpec,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";

const columnHelper = createMRTColumnHelper<PlaceOfPerson>();

export const placeOfPersonColumns: MRT_ColumnDef<PlaceOfPerson, any>[] = [
  columnHelper.accessor("fromDoc", {
    header: "Person",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("toDoc", {
    header: "Connected To Place",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("system_place_of_person_type", {
    header: "Place Of Person Type",
    Cell: ({ cell }) =>
      SYSTEM_PLACE_OF_PERSON_TYPE_LABELS[cell.getValue<SystemPlaceOfPersonTypes>()] ||
      "-",
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const placeOfPersonFilterSpec: FilterSpec = createConnectionFilterSpec({
  system_place_of_person_type: { kind: "string" },
});
